export const SEGMENTED_CONTEXT_NOTIFICATIONS = {
    DELETE_HOTSPOT: {
        SUCCESSFUL: 'Hotspot deleted successfully!',
        ERROR: 'Something went wrong while deleting your hotspot',
    },
    CREATE_HOTSPOT: {
        SUCCESSFUL: 'Hotspot created sucessfully!',
        ERROR: 'An error occurred while creating hotspot',
    },
};
